'use client'

import React, { ReactNode } from 'react'

import Slide, { SlideProps } from '@mui/material/Slide'
import { SnackbarProvider } from 'notistack'

const TransitionUp = (props: SlideProps) => {
  return (
    <Slide
      {...props}
      direction="up"
      /*
       childrenが必須だが設定するとforwardRefの関係かエラーが起きてしまうため設定しない
       公式も設定していない:  https://mui.com/material-ui/react-snackbar/#change-transition
       */
    />
  )
}
export default function SnackbarRegistry({ children }: { children: ReactNode }) {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' } /* 表示位置 */}
      TransitionComponent={TransitionUp}
    >
      {children}
    </SnackbarProvider>
  )
}
